import { useEffect } from "react"
import { createFileRoute } from "@tanstack/react-router"

export const SentryBreakPage = () => {
  return (
    <>
      OMFG
      <InnerError />
    </>
  )
}

export const Route = createFileRoute("/sentry-break")({
  component: SentryBreakPage,
})

const InnerError = () => {
  useEffect(() => {
    throw new Error("ABCD")
  }, [])

  return <></>
}
